import { cleanEntityStyles } from './clean-entity-styles'
import { cleanEntityPrinting } from './clean-entity-printing'
import { cleanEntityPricing } from './clean-entity-pricing'
import { cleanEntityRequirements } from './clean-entity-requirements'
import { cleanEntityInclusions } from './clean-entity-inclusions'
import { cleanEntitySuggestions } from './clean-entity-suggestions'
import { cleanEntityTaxes } from './clean-entity-taxes'
import { cleanEntityKps } from './clean-entity-kps'

export function cleanDepartmentItem (item, department, menuBlob, forPublish = false) {
  cleanEntityPrinting(item, department, menuBlob)
  cleanEntityKps(item, department, menuBlob)
  cleanEntityTaxes(item, menuBlob)
  cleanEntityStyles(item, department)
  cleanEntityPricing(item, department, menuBlob, forPublish)
  cleanEntityRequirements(item, department, menuBlob)
  cleanEntityInclusions(item, menuBlob)
  cleanEntitySuggestions(item, menuBlob)
}
